export const FAVORITE = {
  TITLE_SECTION_DEFAULT: "Favoritos",
  TITLE_DASHBOARD: "Lista de Resultados",
};